import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext";
import "../Login.css";

function AddEmail() {
  const { requestEmailVerification, verifyEmail } = useAuth();

  const location = useLocation();
  const navigate = useNavigate();

  // ข้อมูลที่ส่งมาจาก Login.jsx
  const { fullname, idvender, userinuse } = location.state || {};

  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");

  const [step, setStep] = useState(1);

  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  const [loading, setLoading] = useState(false);

  // ================================
  // ส่ง OTP ไป Email
  // ================================
  const handleSendOTP = async () => {
    setError("");
    setMessage("");

    if (!email) {
      setError("Please enter your email.");
      return;
    }

    // ตรวจสอบรูปแบบ Email เบื้องต้น
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {
      setError("Please enter a valid email address.");
      return;
    }

    if (!userinuse) {
      setError("User information not found. Please login again.");
      return;
    }

    try {
      setLoading(true);

      const result = await requestEmailVerification(userinuse, email);

      if (result.success) {
        setMessage("Verification code has been sent to your email.");

        setStep(2);
      } else {
        setError(result.message || "Unable to send verification code.");
      }
    } catch (err) {
      console.error(err);
      setError("Server error.");
    } finally {
      setLoading(false);
    }
  };

  // ================================
  // Verify OTP
  // ================================
  const handleVerifyOTP = async () => {
    setError("");
    setMessage("");

    if (!otp) {
      setError("Please enter verification code.");
      return;
    }

    if (!userinuse) {
      setError("User information not found. Please login again.");
      return;
    }

    try {
      setLoading(true);

      const result = await verifyEmail(userinuse, email, otp);

      if (result.success) {
        setMessage("Email verified successfully.");

        // ไปหน้า Welcome
        setTimeout(() => {
          navigate("/welcome", {
            state: {
              fullname,
              idvender,
              userinuse,
              email,
            },
          });
        }, 800);
      } else {
        setError(result.message || "Invalid verification code.");
      }
    } catch (err) {
      console.error(err);
      setError("Server error.");
    } finally {
      setLoading(false);
    }
  };

  // ================================
  // ถ้าไม่มี User Information
  // ================================
  if (!userinuse) {
    return (
      <div className="login-container">
        <div className="login-box">
          <h2>Session Expired</h2>

          <p className="error-message">User information not found.</p>

          <button className="login-button" onClick={() => navigate("/")}>
            Back to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-box">
        {/* Logo */}
        <img
          src="assets/logo.png"
          alt="Company Logo"
          className="logo"
          style={{
            width: "150px",
            marginBottom: "1px",
          }}
        />

        <h1 className="portal-title">Supplier Portal</h1>

        {/* ========================= */}
        {/* STEP 1 : ENTER EMAIL */}
        {/* ========================= */}

        {step === 1 && (
          <>
            <h2>Add Email</h2>

            <p style={{ color: "#555" }}>Please enter your email address.</p>

            <div className="form-group">
              <label htmlFor="email">Email</label>

              <input
                id="email"
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSendOTP();
                  }
                }}
              />
            </div>

            {error && <p className="error-message">{error}</p>}

            {message && <p className="success-message">{message}</p>}

            <button
              className="login-button"
              onClick={handleSendOTP}
              disabled={loading}
            >
              {loading ? "Sending..." : "Send Verification Code"}
            </button>

            <p
              className="back-to-login"
              onClick={() => navigate("/")}
              style={{ cursor: "pointer" }}
            >
              ← Back to Login
            </p>
          </>
        )}

        {/* ========================= */}
        {/* STEP 2 : ENTER OTP */}
        {/* ========================= */}

        {step === 2 && (
          <>
            <h2>Verify Email</h2>

            <p style={{ color: "#555" }}>We sent a verification code to:</p>

            <p
              style={{
                fontWeight: "bold",
                color: "#333",
              }}
            >
              {email}
            </p>

            <div className="form-group">
              <label htmlFor="otp">Verification Code</label>

              <input
                id="otp"
                type="text"
                inputMode="numeric"
                maxLength={6}
                placeholder="Enter 6-digit code"
                value={otp}
                onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleVerifyOTP();
                  }
                }}
              />
            </div>

            {error && <p className="error-message">{error}</p>}

            {message && <p className="success-message">{message}</p>}

            <button
              className="login-button"
              onClick={handleVerifyOTP}
              disabled={loading}
            >
              {loading ? "Verifying..." : "Verify Email"}
            </button>

            <p
              className="back-to-login"
              onClick={() => {
                setStep(1);
                setOtp("");
                setError("");
                setMessage("");
              }}
              style={{ cursor: "pointer" }}
            >
              ← Change Email
            </p>
          </>
        )}

        <div className="login-footer">© 2026 Supplier Portal</div>
      </div>
    </div>
  );
}

export default AddEmail;
